const isHttpUrl = (raw: string): boolean => /^https?:\/\//i.test(raw.trim());

const isWindowsPath = (raw: string): boolean => /^[A-Za-z]:\\/.test(raw.trim());

const isUncPath = (raw: string): boolean => /^\\\\[^\\]+\\[^\\]+/.test(raw.trim());

const toFileUrl = (windowsPath: string): string => {
  const trimmed = windowsPath.trim();
  const encoded = trimmed
    .replace(/\\/g, '/')
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  return `file:///${encoded}`;
};

/** Unwrap [[copyable]] and file:/// — same rules as copy popup. */
export function normalizeNoteSelectionText(raw: string): string {
  let value = (raw ?? '').trim();
  if (!value) {
    return '';
  }

  const copyable = value.match(/^\[\[([\s\S]*)\]\]$/);
  if (copyable) {
    value = copyable[1].trim();
  }

  if (/^file:\/\/\//i.test(value)) {
    try {
      value = decodeURIComponent(value.replace(/^file:\/\/\//i, '')).replace(/\//g, '\\');
    } catch {
      value = value.replace(/^file:\/\/\//i, '').replace(/\//g, '\\');
    }
  }

  return value.trim();
}

export function getNoteSelectionCopyText(raw: string): string {
  return normalizeNoteSelectionText(raw);
}

const NOTE_APP_PATH_RE = /^\/notes\/[a-z0-9-]+(?:\/edit)?\/?$/i;

/** Resolved href for View, or null when View does not apply. */
export function resolveNoteSelectionViewHref(raw: string): string | null {
  const value = normalizeNoteSelectionText(raw);
  if (!value) {
    return null;
  }

  if (isHttpUrl(value)) {
    return value;
  }

  if (isWindowsPath(value) || isUncPath(value)) {
    return toFileUrl(value);
  }

  if (NOTE_APP_PATH_RE.test(value)) {
    const path = value.replace(/\/edit\/?$/, '') || value;
    return `${window.location.origin}${path}`;
  }

  const inText = value.match(/\/notes\/([a-z0-9-]+)/i);
  if (inText && value.length < 120) {
    return `${window.location.origin}/notes/${inText[1]}`;
  }

  return null;
}

export function canViewNoteSelection(raw: string): boolean {
  return resolveNoteSelectionViewHref(raw) !== null;
}

export function openNoteSelectionView(raw: string): boolean {
  const href = resolveNoteSelectionViewHref(raw);
  if (!href) {
    return false;
  }
  window.open(href, '_blank', 'noopener,noreferrer');
  return true;
}
